import logo from './logo.svg';
import './App.css';
import BuyerForm from './forms/BuyerForm';

function App() {
  return (
    <div>
        <BuyerForm />
    </div>
  );
}

export default App;
